Wee.fn.make('heritage', {
	init: function() {
		var priv = this.$private;

		priv.toggleHeritageEvent();
		priv.scrollToTop($('ref:backToTop'));
	},
	unload: function() {
		$.events.off(null, '.heritage');
	}
}, {
	scrollToTop: function($el) {
		$el.on('click.heritage', function() {
			$._body.scrollTop = 0;
		});
	},
	toggleHeritageEvent: function() {
		var scope = this,
			$toggle = $('ref:heritageToggle');

		$toggle.on({
			click: function(e, el) {
				scope.toggleheritage(el);
			},
			keydown: function(e, el) {
				if (e.keyCode == 13) {
					scope.toggleheritage(el);
				}
			}
		}, {
			namespace: 'heritage'
		});
	},
	toggleheritage: function(el) {
		var $el = $(el),
			$detail = $el.siblings('ref:heritageDetail'),
			$title = $el.siblings('ref:heritageTitle');

			$detail.toggle();
			$el.toggleClass('-hide-icon');

		if (! $detail.hasClass('js-hide')) {
			$title.hide();
			$el.attr({
				'aria-selected': 'true',
				'aria-expanded': 'true'
			});
			$detail.attr('aria-hidden', 'false');
		} else {
			$title.show();
			$el.attr({
				'aria-selected': 'false',
				'aria-expanded': 'false'
			});
			$detail.attr('aria-hidden', 'true');
		}
	}
});